import { render, staticRenderFns } from "./UnsupportedBrowser.vue?vue&type=template&id=6238f271&scoped=true&"
import script from "./UnsupportedBrowser.vue?vue&type=script&lang=ts&"
export * from "./UnsupportedBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./UnsupportedBrowser.vue?vue&type=style&index=0&id=6238f271&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6238f271",
  null
  
)

export default component.exports